export default "__VITE_ASSET__C3iEwi89__"